import React from "react";
import AdminDashboard from "./admin-dashboard";

export const AdminDashboardRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "admin-dashboard",
      element: <AdminDashboard />,
    },
  ],
};
